export const AI_TRANSLATE_JSON = {
  PENDING: 'AI_TRANSLATE_JSON_PENDING',
  FULFILLED: 'AI_TRANSLATE_JSON_FULFILLED',
  REJECTED: 'AI_TRANSLATE_JSON_REJECTED',
};

export const SET_AI_TARGET_LANG = 'SET_AI_TARGET_LANG';
export const SET_AI_JSON = 'SET_AI_JSON';
export const SET_AI_SAVED = 'SET_AI_SAVED';
export const RESET_AI_STATE = 'RESET_AI_STATE';
